import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SETTINGS_GET, SETTINGS_SAVE } from "../../api/constApi";
import { settingsGetApi, settingsSaveApi } from "../Services/settingsService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const getSettings = createAsyncThunk("settings/get", async () => {
    const response = await settingsGetApi();
    return response.data;
});

export const saveSettings = createAsyncThunk("settings/save", async (payload) => {
    const response = await settingsSaveApi(payload);
    return response.data;
});

export const settingsSlice = createSlice({
    name: "settings",
    initialState: {
        settings: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getSettings.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getSettings.fulfilled, (state, action) => {
            state.loading = false;
            state.settings = action?.payload?.Data;
        });
        builder.addCase(getSettings.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(saveSettings.fulfilled, (state, action) => {
            state.settings = action?.payload?.Data;
        });
    }
});

export default settingsSlice.reducer;

export const selectSettings = (state) => state?.settings?.settings;
export const useSettings = () => {
    const settings = useSelector(selectSettings);
    return useMemo(() => settings, [settings]);
};
